define((require) => {
    const TagCompositeView          = require("ui/assets/image/TagCompositeView");
    const ImageTagTrackingBehavior  = require("ui/assets/image/tags/ImageTagTrackingBehavior");
    const template                  = require("ui/assets/image/tags/ImageTagCompositeView.tpl");

    /**
     * Renders a collection of tags.
     *
     * @see ImageTagCollection
     * @see ImageTagModel
     *
     * @class ImageTagCompositeView
     */
    return TagCompositeView.extend({

        template,

        events: {
            "submit .image-tag-new-form": "_tagSubmitHandler",
            "keydown @ui.tagInput": "_tagInputKeydownHandler"
        },

        behaviors: {
            imageTagTracking: {
                behaviorClass: ImageTagTrackingBehavior
            }
        },

        ui: {
            formGroup: ".form-group",
            tagInput: ".tag-input",
            tagInputMessage: ".tag-input-message"
        },

        itemViewOptions() {
            return {
                editable: this.options.editable,
                triggerSource: this
            };
        },

        templateHelpers() {
            return {
                editable: this.options.editable,
                maxNameLength: this.itemView.TAG_NAME_MAX_LENGTH
            };
        },

        _tagSubmitHandler() {
            const newTagNameValue = this.$input.val().trim();
            const validation = this._validateTag(newTagNameValue);

            this.$formGroup.toggleClass("has-error", !validation.valid);
            if (validation.valid) {
                const newTag = {name: newTagNameValue};
                this.collection.add(newTag, {triggerSource: this});
                this.options.tagCollection.add(newTag, {triggerSource: this});
                this.$input.val("");
            } else {
                this.$el.find(this.ui.tagInputMessage).text(validation.error);
            }

            return false;
        },

        _validateTag(value) {
            if (value.length === 0) {
                return {
                    valid: false,
                    error: "Missing tag name"
                };
            }

            const existingName = this.collection.find((model) => {
                return model.get("name").toUpperCase() === value.toUpperCase();
            });

            if (existingName) {
                return {
                    valid: false,
                    error: "Tag already exists!"
                };
            }

            return {
                valid: true,
                error: null
            };
        },

        onRender() {
            this.$input = this.$el.find(this.ui.tagInput);
            this.$formGroup = this.$el.find(this.ui.formGroup);

            if (this._focusInputOnRender) {
                this.$el.find(this.ui.tagInput).focus();
                this._focusInputOnRender = false;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/tags/ImageTagCompositeView.js